<template>
  <v-container class="leis-decretos">
    <v-card
      class="py-4 px-2 auth-content"
      tile
    >
      <v-form
        v-model="valid"
        ref="form"
      >
        <PageTitle
          main="Administração"
          icon="mdi-pencil-box-outline"
          sub="Leis e decretos"
          home="/administracao"
        />
        <input
          id="user-id"
          type="hidden"
          v-model="lei.usuario"
        />
        <input
          id="lei-id"
          type="hidden"
          v-model="lei.id"
        />
        <input
          id="lei-uuid"
          type="hidden"
          v-model="lei.uuid"
        />
        <v-row>
          <v-col
            cols="12"
            md="2"
            lg="2"
          >
            <v-text-field
              v-model="codigo"
              label="Código"
              dense
              outlined
            >
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="success"
                tile
                @click.prevent="loadDialog"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="2"
            v-if="codigo"
          >
            <v-checkbox
              v-model="lei.inativar"
              label="Inativar lei?"
              color="success"
              v-show="mode === 'save'"
            ></v-checkbox>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="3"
          >
            <v-menu
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              transition="scale-transition"
              offset-y
              min-width="auto"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-text-field
                  v-mask="dtp"
                  v-model="data_pub"
                  label="Data de publicação.:"
                  dense
                  outlined
                  @blur="mudaData"
                >
                  <v-icon
                    slot="append"
                    color="success"
                    large
                    v-bind="attrs"
                    v-on="on"
                  >
                    mdi-calendar
                  </v-icon>
                </v-text-field>
              </template>
              <v-date-picker
                locale="pt-br"
                v-model="date"
                @input="dateB"
              >
              </v-date-picker>
            </v-menu>
          </v-col>
          <v-col
            cols="12"
            md="6"
            lg="4"
          >
            <v-checkbox
              v-model="lei.correlacionado"
              label="Correlacionado à outros atos?"
              color="success"
            ></v-checkbox>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="2"
          >
            <v-autocomplete
              v-model="lei.uid_tipolei"
              :items="leisTipo"
              clearable
              required
              dense
              outlined
              label="Tipo de Lei"
            ></v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-autocomplete
              v-model="lei.uid_normativa"
              :items="normativas"
              required
              clearable
              dense
              outlined
              label="Espécie normativa"
            ></v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="2"
          >
            <v-autocomplete
              v-model="lei.origem"
              :items="origem"
              required
              dense
              outlined
              label="Orígem da lei"
            ></v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="3"
          >
            <v-autocomplete
              v-model="lei.uid_orgao"
              :items="orgaos"
              clearable
              required
              dense
              outlined
              label="Órgão"
            >
            </v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
            md="2"
            lg="2"
          >
            <v-text-field
              v-model="lei.numero"
              label="Número da lei"
              required
              dense
              outlined
              hint="Exemplo.: 001 sem o ano"
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="2"
            lg="2"
          >
            <v-text-field
              v-model="lei.ano"
              label="Ano"
              required
              dense
              outlined
            >
            </v-text-field>
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="2"
          >
            <v-text-field
              v-model="codProposicao"
              label="Proposição"
              dense
              outlined
            >
              <v-btn
                class="btn-outer-right pa-0"
                slot="append"
                color="success"
                tile
                @click.prevent="loadDialogProposicao"
              >
                <v-icon
                  class="mx-0"
                  color="white"
                >
                  mdi-magnify
                </v-icon>
              </v-btn>
            </v-text-field>
            <input
              type="hidden"
              id="uid-prosicao"
              v-model="lei.uid_proposicao"
            />
          </v-col>
          <v-col
            cols="12"
            md="3"
            lg="3"
          >
            <v-autocomplete
              v-model="lei.uid_modo"
              :items="modos"
              required
              dense
              outlined
              label="Modo"
            ></v-autocomplete>
          </v-col>
          <v-col
            cols="12"
            md="4"
            lg="3"
            v-if="lei.id"
          >
            <v-autocomplete
              v-model="lei.uid_situacao"
              :items="situacoes"
              required
              dense
              outlined
              label="Situação"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12">
            <v-textarea
              v-model="lei.ementa"
              label="Ementa"
              rows="2"
              dense
              outlined
            ></v-textarea>
            <v-text-field
              v-model="lei.assunto"
              label="Assunto"
              required
              dense
              outlined
            ></v-text-field>
          </v-col>
        </v-row>
        <v-card v-if="lei.id">
          <v-tabs
            background-color="primary"
            dark
            v-model="tabs"
          >
            <v-tab @click="loadPastaAnexos">
              <v-icon class="mr-1">
                mdi-paperclip
              </v-icon>
              Anexos
            </v-tab>
            <v-tab
              :disabled="lei.correlacionado === false"
              @click="loadRelacionamentos"
            >
              <v-icon class="mr-1">
                mdi-relation-zero-or-one-to-zero-or-one
              </v-icon>
              Correlato
            </v-tab>
            <v-tab @click="loadAutores">
              <v-icon class="mr-1">
                mdi-account-file-outline
              </v-icon>
              Agenete pub.
            </v-tab>
            <v-tab @click="loadUnidades">
              <v-icon class="mr-1">
                mdi-account-file-outline
              </v-icon>
              Unidades
            </v-tab>
            <v-tab @click="loadLeiHtml">
              <v-icon
                color="purple"
                class="mr-1"
              >
                mdi-code-tags
              </v-icon>
              Html
            </v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersAnexos"
                        :items="anexos"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            large
                            color="success"
                            class="mr-2"
                            @click="loadAnexo(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3"
                            v-if="codigo"
                            @click="AddAnexo"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add anexo
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersCorrel"
                        :items="relacionamentos"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            large
                            color="success"
                            class="mr-2"
                            @click="loadCorrelato(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3 text-none"
                            v-if="codigo"
                            @click="AddCorrelato"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Adicionar
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersAutores"
                        :items="autores"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            large
                            color="success"
                            class="mr-2"
                            @click="loadAutor(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3 text-none"
                            v-if="codigo"
                            @click="loadModalAutor"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add interessado
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-row justify="space-around">
                  <v-col
                    cols="12"
                    md="12"
                  >
                    <v-card>
                      <v-data-table
                        :headers="headersUnidades"
                        :items="unidades"
                        :search="search"
                      >
                        <template v-slot:[`item.actions`]="{ item }">
                          <v-icon
                            large
                            color="success"
                            class="mr-2"
                            @click="loadUnidade(item)"
                          >
                            mdi-square-edit-outline
                          </v-icon>
                        </template>
                      </v-data-table>
                      <v-row>
                        <v-col
                          cols="12"
                          md="6"
                        >
                          <v-btn
                            color="success"
                            class="ml-1 mb-3 text-none"
                            v-if="codigo"
                            @click="loadModalUnidade"
                          >
                            <v-icon left>
                              mdi-content-save
                            </v-icon>
                            Add unidade
                          </v-btn>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card>
            </v-tab-item>
            <v-tab-item>
              <v-card flat>
                <v-card-subtitle class="my-0 py-0">Texto da lei</v-card-subtitle>
                <v-card class="pa-2">
                  <v-textarea
                    v-model="leiHtml.html"
                    label="HTML da lei"
                    outlined
                    rows="25"
                    auto-grow
                    class="font-mono"
                  />
                </v-card>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="success"
                    class="ml-1 mr-4"
                    v-if="mode === 'updateHtml'"
                    @click="saveHtlm"
                  >
                    <v-icon left>
                      mdi-code-tags-check
                    </v-icon>
                    Salvar html
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
        <v-row class="mt-1">
          <v-col
            cols="12"
            md="6"
          >
            <v-btn
              :disabled="!valid"
              color="success"
              class="ml-1 mr-4"
              v-if="mode === 'save'"
              @click="save"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Salvar
            </v-btn>
            <v-btn
              color="error"
              class="mr-4"
              v-if="mode === 'remove'"
              @click="remove"
            >
              <v-icon left>
                mdi-content-save
              </v-icon>
              Deletar
            </v-btn>
            <v-btn
              color="secondary"
              class="mr-4"
              @click="reset"
            >
              <v-icon left>
                mdi-broom
              </v-icon>
              Limpar
            </v-btn>
          </v-col>
        </v-row>
      </v-form>
      <v-row justify="space-around">
        <v-col cols="auto">
          <v-dialog
            v-model="dialog"
            transition="dialog-bottom-transition"
            fullscreen
          >
            <template v-slot:default="dialog">
              <v-card>
                <v-toolbar
                  color="primary"
                  dark
                >
                  Pesquisar leis
                </v-toolbar>
                <v-card-title>
                  <v-text-field
                    class="search"
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Pesquisar"
                    single-line
                    hide-details
                  >
                  </v-text-field>
                </v-card-title>
                <v-data-table
                  :headers="headers"
                  :items="leis"
                  :search="search"
                >
                  <template v-slot:[`item.actions`]="{ item }">
                    <v-icon
                      large
                      color="success"
                      class="mr-2"
                      @click="loadLei(item)"
                    >
                      mdi-square-edit-outline
                    </v-icon>
                  </template>
                </v-data-table>
                <v-card-actions class="justify-end">
                  <v-btn
                    color="error"
                    @click="dialog.value = false"
                  >Fechar</v-btn>
                </v-card-actions>
              </v-card>
            </template>
          </v-dialog>
        </v-col>
      </v-row>
      <!-- Dialog de filtro de leis a correlacionar -->
      <v-container>
        <v-dialog
          v-model="dialogFiltro"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialogFiltro">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar leis
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headers"
                :items="leis"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click="loadAddLei(item)"
                  >
                    mdi-arrow-down-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialogFiltro.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog de filtro de projetos de lei -->
      <v-container>
        <v-dialog
          v-model="dialogProposicao"
          transition="dialog-bottom-transition"
          fullscreen
        >
          <template v-slot:default="dialogProposicao">
            <v-card>
              <v-toolbar
                color="primary"
                dark
              >
                Pesquisar
              </v-toolbar>
              <v-card-title>
                <v-text-field
                  class="search"
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Pesquisar"
                  single-line
                  hide-details
                >
                </v-text-field>
              </v-card-title>
              <v-data-table
                :headers="headersProcessos"
                :items="processos"
                :search="search"
              >
                <template v-slot:[`item.actions`]="{ item }">
                  <v-icon
                    large
                    color="success"
                    class="mr-2"
                    @click.prevent="loadProcesso(item)"
                  >
                    mdi-arrow-down-bold-box
                  </v-icon>
                </template>
              </v-data-table>
              <v-card-actions class="justify-end">
                <v-btn
                  color="error"
                  @click="dialogProposicao.value = false"
                >Fechar</v-btn>
              </v-card-actions>
            </v-card>
          </template>
        </v-dialog>
      </v-container>
      <!-- Dialog de relacionamentos -->
      <v-container>
        <v-dialog
          v-model="dialogCorrelato"
          transition="dialog-top-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <div class="logo-foto altura">
              <PageTitle
                icon="mdi-pencil-box-outline"
                sub="Adicionar correlacionamentos"
              />
              <input
                id="user-id"
                type="hidden"
                v-model="relacionamento.usuario"
              />
              <input
                id="anexo-id"
                type="hidden"
                v-model="relacionamento.id"
              />
              <v-row>
                <v-col
                  cols="12"
                  md="2"
                >
                  <v-text-field
                    v-model="codigoRelac"
                    label="Código"
                    dense
                    outlined
                  >
                    <v-btn
                      class="btn-outer-right pa-0"
                      slot="append"
                      color="success"
                      tile
                    >
                      <v-icon
                        class="mx-0"
                        color="white"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="codigoRelac"
                >
                  <v-checkbox
                    v-model="relacionamento.inativar"
                    label="Inativar relação?"
                    color="success"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="3"
                  lg="2"
                >
                  <v-text-field
                    v-model="nrleicorrelato"
                    label="Lei"
                    dense
                    outlined
                  >
                    <v-btn
                      class="btn-outer-right pa-0"
                      slot="append"
                      color="success"
                      tile
                      @click.prevent="loadDialogFiltro"
                    >
                      <v-icon
                        class="mx-0"
                        color="white"
                      >
                        mdi-magnify
                      </v-icon>
                    </v-btn>
                  </v-text-field>
                  <input
                    type="hidden"
                    id="nr-lei-correlato"
                    v-model="relacionamento.nr_lei"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="2"
                  lg="2"
                >
                  <v-text-field
                    v-model="anoleicorrelato"
                    label="Ano"
                    dense
                    outlined
                  >
                  </v-text-field>
                  <input
                    type="hidden"
                    id="ano-lei-correlato"
                    v-model="relacionamento.ano"
                  />
                </v-col>
                <v-col
                  cols="12"
                  md="4"
                >
                  <v-autocomplete
                    v-model="relacionamento.uid_tipo_correlato"
                    :items="tiposCorel"
                    required
                    dense
                    outlined
                    label="Tipo de relacionamento"
                  >
                  </v-autocomplete>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12">
                  <v-text-field
                    v-model="relacionamento.ds_correlacionamento"
                    type="text"
                    label="Descrição"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4 text-none"
                v-if="codigoRelac"
                type="submit"
                @click="saveRelacao()"
              >
                <v-icon left>
                  mdi-square-edit-outline
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4 text-none"
                v-if="!codigoRelac"
                type="submit"
                @click="saveRelacao()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4 text-none"
                v-if="codigoRelac"
                @click="delRelacao"
              >
                <v-icon left>
                  mdi-delete-alert-outline
                </v-icon>
                Deletar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4 text-none"
                @click="FecharDialogRel"
              >
                <v-icon left>
                  mdi-exit-run
                </v-icon>
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <v-container>
        <v-dialog
          v-model="DialogAnexo"
          transition="dialog-top-transition"
        >
          <v-card
            class="py-4 px-2 auth-content"
            tile
          >
            <div class="logo-foto altura">
              <PageTitle
                icon="mdi-pencil-box-outline"
                sub="Adicionar anexo"
              />
              <input
                id="user-id"
                type="hidden"
                v-model="anexo.usuario"
              />
              <input
                id="anexo-id"
                type="hidden"
                v-model="anexo.id"
              />
              <v-row>
                <v-col
                  cols="12"
                  md="7"
                  lg="6"
                >
                  <v-text-field
                    v-model="anexo.nome"
                    type="text"
                    label="Nome do arquivo"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col
                  cols="12"
                  md="5"
                  lg="3"
                >
                  <v-menu
                    v-model="menu1"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="auto"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        v-mask="datp"
                        v-model="date_pub"
                        label="Data de publicacao.:"
                        dense
                        outlined
                        @blur="mudaDataA"
                      >
                        <v-icon
                          slot="append"
                          color="success"
                          large
                          v-bind="attrs"
                          v-on="on"
                        >
                          mdi-calendar
                        </v-icon>
                      </v-text-field>
                    </template>
                    <v-date-picker
                      locale="pt-br"
                      v-model="date1"
                      @input="dateA"
                    >
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col
                  cols="12"
                  md="3"
                  v-if="anexo.id"
                >
                  <v-checkbox
                    v-model="anexo.inativar"
                    label="Inativar anexo?"
                    color="success"
                    v-show="mode === 'save'"
                  ></v-checkbox>
                </v-col>
              </v-row>
              <v-row>
                <v-col
                  cols="12"
                  md="10"
                  lg="10"
                >
                  <v-text-field
                    v-model="anexo.url"
                    type="text"
                    label="Link do arquivo"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
              </v-row>
              <v-row v-if="!anexo.id">
                <v-col cols="12">
                  <input
                    accept="application/vnd.ms-excel, application/pdf"
                    prepend-icon="mdi-camera"
                    label="Anexo"
                    v-if="uploadReady"
                    type="file"
                    ref="file"
                    @change="selectFile()"
                  >
                </v-col>
              </v-row>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4 text-none"
                v-if="anexo.id"
                type="submit"
                @click="saveAnexo()"
              >
                <v-icon left>
                  mdi-square-edit-outline
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4 text-none"
                v-if="!anexo.id"
                type="submit"
                @click.prevent="fileUpload()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4 text-none"
                v-if="!anexo.id"
                @click="clearUpload"
              >
                <v-icon left>
                  mdi-broom
                </v-icon>
                Limpar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4 text-none"
                v-if="this.anexo.id && btnDel === false"
                @click="removeAnexo"
              >
                <v-icon left>
                  mdi-delete-alert-outline
                </v-icon>
                Remover
              </v-btn>
              <v-btn
                color="error"
                class="mr-4 text-none"
                v-if="this.anexo.id && btnDel === true"
                @click="restoreAnexo"
              >
                <v-icon left>
                  mdi-file-restore-outline
                </v-icon>
                Restaurar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4 text-none"
                @click="FecharDialog"
              >
                <v-icon left>
                  mdi-exit-run
                </v-icon>
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog dos autores ou interessados -->
      <v-container>
        <v-dialog
          v-model="DialogAutor"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              Adicionar ou editar interessaados ao processo
            </v-toolbar>
            <div class="logo-foto ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="autor.usuario"
                />
                <input
                  id="uid_processo"
                  type="hidden"
                  v-model="autor.uid_processo"
                />
                <input
                  id="autor-id"
                  type="hidden"
                  v-model="autor.id"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codigo"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                    v-if="autor.id"
                  >
                    <v-checkbox
                      v-model="autor.inativar"
                      label="Inativar pessoa?"
                      color="success"
                      class="mt-4"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="autor.uid_interessado"
                      label="Código interessado..."
                      dense
                      outlined
                      flat
                      @change="loadAutorSel()"
                    >
                      <v-btn
                        class="btn-outer pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click="loadFtAutor"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="light"
                        tile
                        @click="loadAddPessoa"
                      >
                        <v-icon
                          class="mx-0"
                          color="black"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="5"
                  >
                    <v-text-field
                      v-if="autor.interessado"
                      v-model="autor.interessado"
                      label="Autor ou interessado"
                      outlined
                      dense
                      class="ml-n6"
                    >
                      <v-icon
                        v-if="autor.interessado"
                        slot="append"
                        color="black"
                        @click="clPessoa"
                      >
                        mdi-close
                      </v-icon>
                    </v-text-field>
                    <v-autocomplete
                      v-if="!autor.interessado"
                      v-model="filtro"
                      :items="items"
                      :search-input.sync="ftpessoa"
                      cache-items
                      dense
                      outlined
                      hide-no-data
                      hide-details
                      label="Autor ou interessado"
                      class="ml-n6"
                      @change="loadAutorSel()"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="10"
                    lg="7"
                    class="mx-1 px-1"
                  >
                    <v-text-field
                      v-model="autor.nome"
                      label="Angete público vinculado"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="autor.id"
                type="submit"
                @click.prevent="saveAutor()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!autor.id"
                type="submit"
                @click.prevent="saveAutor()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4 text-none"
                v-if="autor.id"
                @click="delAutor"
              >
                <v-icon left>
                  mdi-delete-alert-outline
                </v-icon>
                Deletar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
      <!-- Dialog de unidades vinculadas -->
      <v-container>
        <v-dialog
          v-model="DialogUnidade"
          transition="dialog-top-transition"
        >
          <v-card tile>
            <v-toolbar
              color="primary"
              dark
              class="mb-2"
            >
              Adicionar ou editar unidades ao processo
            </v-toolbar>
            <div class="logo-foto ml-4 mt-5">
              <v-form>
                <input
                  id="user-id"
                  type="hidden"
                  v-model="unidade.usuario"
                />
                <input
                  id="unidade-id"
                  type="hidden"
                  v-model="unidade.id"
                />
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="codigo"
                      label="Código"
                      dense
                      outlined
                    >
                    </v-text-field>
                  </v-col>
                  <v-col
                    colls="12"
                    lg="3"
                    md="4"
                    v-if="unidade.id"
                  >
                    <v-checkbox
                      v-model="unidade.inativar"
                      label="Inativar unidade?"
                      color="success"
                      class="mt-4"
                    >
                    </v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                    lg="2"
                  >
                    <v-text-field
                      v-model="unidade.uid_sessao"
                      label="Código unidade..."
                      dense
                      outlined
                      flat
                      @change="loadUnidadeSel()"
                    >
                      <v-btn
                        class="btn-outer pa-0"
                        slot="append"
                        color="success"
                        tile
                        @click="loadFtUnidade"
                      >
                        <v-icon
                          class="mx-0"
                          color="white"
                        >
                          mdi-magnify
                        </v-icon>
                      </v-btn>
                      <v-btn
                        class="btn-outer-right pa-0"
                        slot="append"
                        color="light"
                        tile
                        @click="loadAddPessoa"
                      >
                        <v-icon
                          class="mx-0"
                          color="black"
                        >
                          mdi-plus
                        </v-icon>
                      </v-btn>
                    </v-text-field>
                  </v-col>
                  <v-col
                    cols="12"
                    md="6"
                    lg="5"
                  >
                    <v-text-field
                      v-if="unidade.sessao"
                      v-model="unidade.sessao"
                      label="Unidade ou interessado"
                      outlined
                      dense
                      class="ml-n6"
                    >
                      <v-icon
                        v-if="unidade.sessao"
                        slot="append"
                        color="black"
                        @click="clUnidade"
                      >
                        mdi-close
                      </v-icon>
                    </v-text-field>
                    <v-autocomplete
                      v-if="!unidade.sessao"
                      v-model="filtro"
                      :items="items"
                      :search-input.sync="ftunidade"
                      cache-items
                      dense
                      outlined
                      hide-no-data
                      hide-details
                      label="Unidade ou interessado"
                      class="ml-n6"
                      @change="loadUnidadeSel()"
                    >
                    </v-autocomplete>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="10"
                    lg="7"
                    class="mx-1 px-1"
                  >
                    <v-text-field
                      v-model="unidade.prefixo"
                      label="Prefixo da unidade"
                      outlined
                      dense
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-form>
            </div>
            <v-card-actions class="justify-end">
              <v-btn
                color="success"
                class="mr-4"
                v-if="codUn"
                type="submit"
                @click.prevent="saveUnidade()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Atualizar
              </v-btn>
              <v-btn
                color="success"
                class="mr-4"
                v-if="!codUn"
                type="submit"
                @click.prevent="saveUnidade()"
              >
                <v-icon left>
                  mdi-content-save
                </v-icon>
                Salvar
              </v-btn>
              <v-btn
                color="error"
                class="mr-4 text-none"
                v-if="codUn"
                @click="delUnidade"
              >
                <v-icon left>
                  mdi-delete-alert-outline
                </v-icon>
                Deletar
              </v-btn>
              <v-btn
                color="danger"
                class="mr-4"
                @click="FecharDialog"
              >
                Sair
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-container>
    </v-card>
  </v-container>
</template>
<script>
import PageTitle from '@/components/template/PageTitle'
import { mapState } from 'vuex'
// mport { VueEditor } from 'vue2-editor'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic'
import { uuid } from 'vue-uuid'
import { baseApiUrl, showError } from '@/global'
import moment from 'moment'
import axios from 'axios'
export default {
  name: 'LeisDecretos',
  components: { PageTitle },
  computed: mapState(['user']),
  data: () => ({
    uuid: '',
    editor: ClassicEditor,
    editorConfig: {
    },
    dtp: '##/##/####',
    datp: '##/##/####',
    nrleicorrelato: null,
    anoleicorrelato: null,
    loading: false,
    filtro: null,
    select: null,
    ftpessoa: null,
    ftunidade: null,
    search: null,
    tabs: null,
    codigo: '',
    codUn: '',
    codProposicao: '',
    codigoRelac: '',
    dialog: false,
    dialogFiltro: false,
    btnDel: null,
    DialogAnexo: false,
    dialogCorrelato: false,
    dialogProposicao: false,
    DialogAutor: false,
    DialogUnidade: false,
    uploadReady: true,
    file: '',
    tabela: 'leianexos',
    pasta: '',
    date: new Date().toISOString().substr(0, 10),
    date1: new Date().toISOString().substr(0, 10),
    data_pub: '',
    date_pub: '',
    menu: false,
    menu1: false,
    mode: 'save',
    lei: {},
    leiHtml: {},
    leift: {},
    anexo: {},
    items: [],
    autores: [],
    orgaos: [],
    autor: {},
    pessoa: {},
    unidad: {},
    delAnexos: {},
    unidade: {},
    pastas: {},
    unidades: [],
    normativas: [],
    processos: [],
    situacoes: [],
    relacionamento: {},
    relacionamentos: [],
    modos: [],
    anexos: [],
    tiposCorel: [],
    sessoes: [],
    leis: [],
    leisTipo: [],
    headers: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Lei', value: 'numero' },
      { text: 'Ano', value: 'ano' },
      { text: 'Ementa', value: 'ementa' },
      { text: 'Publicação', value: 'data' },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersProcessos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Título', value: 'titulo' },
      { text: 'Processo', value: 'processo' },
      { text: 'Projeto', value: 'projeto' },
      { text: 'Ano', value: 'ano_projeto' },
      { text: 'Data', value: 'cadastro' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAnexos: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome', value: 'nome' },
      { text: 'Tabela', value: 'tabela' },
      { text: 'Status', value: 'lixo' },
      { text: 'Data', value: 'dtpub' },
      { text: 'Link', value: 'url' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersCorrel: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Lei', value: 'lei' },
      { text: 'Tipo', value: 'correlacionamento' },
      { text: 'Descrição', value: 'ds_correlacionamento' },
      { text: 'Data', value: 'dtpub' },
      { text: 'Status', value: 'status' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersAutores: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome de batismo', value: 'interessado' },
      { text: 'Agente público', value: 'nome' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    headersUnidades: [
      {
        text: 'Cód',
        align: 'start',
        sortable: false,
        value: 'id'
      },
      { text: 'Nome da unidade', value: 'sessao' },
      { text: 'Prefixo', value: 'prefixo' },
      { text: 'Situação', value: 'situacao' },
      { text: 'Ações', value: 'actions', sortable: false }
    ],
    origem: [
      { text: 'Executivo', value: 'Executivo' },
      { text: 'Legislativo', value: 'Legislativo' }
    ],
    valid: false
  }),
  watch: {
    ftpessoa (val) {
      val && val !== this.filtro && this.querySelectionsAutor(val)
    },
    ftunidade (val) {
      val && val !== this.filtro && this.querySelectionsSessao(val)
    }
  },
  methods: {
    querySelectionsAutor (v) {
      const fpessoa = v || 0
      const url = `${baseApiUrl}/agentes-search/${fpessoa}`
      axios.get(url).then(res => {
        this.items = res.data.map(item => {
          return {
            value: item.uid_agente,
            text: item.agente
          }
        })
      })
    },
    querySelectionsSessao (v) {
      const uid = v || 0
      const url = `${baseApiUrl}/sessoes-search/${uid}`
      axios.get(url).then(res => {
        this.items = res.data.map(item => {
          return {
            value: item.uid_sessao,
            text: item.sessao
          }
        })
      })
    },
    dateB () {
      this.data_pub = moment(this.date).format('DD/MM/YYYY')
      this.menu = false
    },
    mudaData () {
      const [dia, mes, ano] = this.data_pub.split('/')
      this.date = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    dateA () {
      this.date_pub = moment(this.date1).format('DD/MM/YYYY')
      this.menu1 = false
    },
    mudaDataA () {
      const [dia, mes, ano] = this.date_pub.split('/')
      this.date1 = `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`
    },
    validate () {
      this.$refs.form.validate()
    },
    save () {
      this.lei.data_publicacao = this.date
      const method = this.lei.id ? 'put' : 'post'
      const id = this.lei.id ? `/${this.lei.id}` : ''
      axios[method](`${baseApiUrl}/legislacao${id}`, this.lei)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    saveHtlm () {
      const method = this.lei.id ? 'put' : 'post'
      const id = this.lei.id ? `/${this.lei.id}` : ''
      axios[method](`${baseApiUrl}/legislacao-html${id}`, this.leiHtml)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.reset()
        })
        .catch(showError)
    },
    selectFile () {
      this.file = this.$refs.file.files[0]
    },
    async fileUpload () {
      const formData = new FormData()
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      const url = `${baseApiUrl}/upload-documentos-em-anexo${id}`
      formData.append('uid_lei', this.lei.id)
      formData.append('data_publicacao', this.date1)
      formData.append('nome', this.anexo.nome)
      formData.append('tabela', this.tabela)
      formData.append('pasta', this.anexo.pasta)
      formData.append('subpasta', this.lei.id)
      formData.append('usuario', this.anexo.usuario)
      formData.append('file', this.file)
      await axios[method](url, formData)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.resetUpload()
        })
        .catch(showError)
    },
    clearUpload () {
      this.uploadReady = false
      this.$nextTick(() => {
        this.uploadReady = true
      })
    },
    saveAutor () {
      const method = this.autor.id ? 'put' : 'post'
      const id = this.autor.id ? `/${this.autor.id}` : ''
      axios[method](`${baseApiUrl}/interessados${id}`, this.autor)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadAutores()
          if (!id) {
            this.clearAutor()
            this.DialogAutor = false
          }
        })
        .catch(showError)
    },
    saveUnidade () {
      const method = this.codUn ? 'put' : 'post'
      const id = this.codUn ? `/${this.codUn}` : ''
      axios[method](`${baseApiUrl}/itens-das-sessoes${id}`, this.unidade)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.loadUnidades()
          if (!this.codUn) {
            this.clearUnidade()
            this.DialogUnidade = false
          }
        })
        .catch(showError)
    },
    delUnidade () {
    },
    saveAnexo () {
      const method = this.anexo.id ? 'put' : 'post'
      const id = this.anexo.id ? `/${this.anexo.id}` : ''
      axios[method](`${baseApiUrl}/anexos${id}`, this.anexo)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.limpar()
          this.loadAnexos()
        })
        .catch(showError)
    },
    saveRelacao () {
      const method = this.relacionamento.id ? 'put' : 'post'
      const id = this.relacionamento.id ? `/${this.relacionamento.id}` : ''
      axios[method](`${baseApiUrl}/correlacionamentos${id}`, this.relacionamento)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.relacionamento = {}
          this.loadRelacionamentos()
          this.dialogCorrelato = false
        })
        .catch(showError)
    },
    restoreAnexo () {
      this.delAnexos.deleted = false
      this.delAnexos.deleted_at = null
      this.upAnexo()
    },
    removeAnexo () {
      this.delAnexos.deleted = true
      this.delAnexos.deleted_at = new Date()
      this.upAnexo()
    },
    upAnexo () {
      const id = this.anexo.id
      const method = 'put'
      axios[method](`${baseApiUrl}/anexo-update/${id}`, this.delAnexos)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.delAnexos = {}
          this.DialogAnexo = false
          this.loadAnexos()
        })
        .catch((showError))
    },
    delRelacao () {
      alert('Deseja realmente remover esta relação?')
      const method = 'delete'
      const id = this.relacionamento.id
      axios[method](`${baseApiUrl}/correlacionamentos/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.relacionamento = {}
          this.loadRelacionamentos()
          this.dialogCorrelato = false
        })
        .catch(showError)
    },
    delAutor () {
      alert('Deseja realmente remover este autor?')
      const method = 'delete'
      const id = this.autor.id
      axios[method](`${baseApiUrl}/interessados/${id}`)
        .then(() => {
          this.$toasted.global.defaultSuccess()
          this.autor = {}
          this.loadUnidades()
          this.DialogAutor = false
        })
        .catch(showError)
    },
    loadPastaAnexos () {
      this.loadAnexos()
      this.loadPastaDasLeis()
    },
    loadAnexos () {
      const id = this.lei.id
      const url = `${baseApiUrl}/anexos-de-lei/${id}`
      axios.get(url).then(res => {
        this.anexos = res.data.map(item => {
          return {
            ...item,
            dtpub: moment(item.data_publicacao).format('DD/MM/YYYY'),
            lixo: item.deleted === 0 ? 'Ativo' : 'Deletado'
          }
        })
      })
    },
    loadNormativas () {
      const url = `${baseApiUrl}/normativas-filtro`
      axios.get(url).then(res => {
        this.normativas = res.data.map(cat => {
          return {
            value: cat.id,
            text: cat.titulo
          }
        })
      })
    },
    loadSessoes () {
      const url = `${baseApiUrl}/lista-sessoes`
      axios.get(url).then(res => {
        this.sessoes = res.data.map(sec => {
          return {
            value: sec.id,
            text: sec.sessao
          }
        })
      })
    },
    loadTipoLeis () {
      const url = `${baseApiUrl}/tipos-de-leis`
      axios.get(url).then(res => {
        this.leisTipo = res.data.map(lei => {
          return {
            value: lei.id,
            text: lei.titulo
          }
        })
      })
    },
    loadPastaDasLeis () {
      const id = this.lei.uid_tipolei
      const url = `${baseApiUrl}/tipo-de-lei/${id}`
      axios.get(url).then(res => {
        this.pastas = res.data
      })
    },
    loadProcessos () {
      const url = `${baseApiUrl}/protocolo-filtro-proposicao`
      axios.get(url).then(res => {
        this.processos = res.data.map(item => {
          return {
            ...item,
            cadastro: moment(item.data_criacao).format('DD/MM/YYYY'),
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadAutores () {
      const id = this.lei.id
      const url = `${baseApiUrl}/interessados-por-lei/${id}`
      axios.get(url).then(res => {
        this.autores = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadUnidades () {
      const id = this.lei.id
      const url = `${baseApiUrl}/lista-sessoes/${id}`
      axios.get(url).then(res => {
        this.unidades = res.data.map(item => {
          return {
            ...item,
            situacao: item.inativar === 0 ? 'Ativo' : 'Inativo'
          }
        })
      })
    },
    loadAutor (item) {
      this.autor = {
        ...item
      }
      this.DialogAutor = true
    },
    loadUnidade (item) {
      this.unidade = {
        ...item
      }
      this.codUn = item.id
      console.log(item)
      this.DialogUnidade = true
    },
    loadSituacoes () {
      const url = `${baseApiUrl}/situacoes`
      axios.get(url).then(res => {
        this.situacoes = res.data.map(sit => {
          return {
            value: sit.id,
            text: sit.situacao
          }
        })
      })
    },
    loadModos () {
      const url = `${baseApiUrl}/modos-de-leis`
      axios.get(url).then(res => {
        this.modos = res.data.map(item => {
          return {
            value: item.id,
            text: item.modo
          }
        })
      })
    },
    loadTipos () {
      const url = `${baseApiUrl}/tipos-de-correlacionamentos`
      axios.get(url).then(res => {
        this.tiposCorel = res.data.map(item => {
          return {
            value: item.id,
            text: item.correlacionamento
          }
        })
      })
    },
    loadLeis () {
      const url = `${baseApiUrl}/legislacao-filtro`
      axios.get(url).then(res => {
        this.leis = res.data.map(item => {
          return {
            ...item,
            data: moment(item.data_publicacao).format('DD/MM/YYYY')
          }
        })
      })
    },
    loadRelacionamentos () {
      const id = this.lei.id
      const url = `${baseApiUrl}/correlacionamentos-filtro/${id}`
      axios.get(url).then(res => {
        this.relacionamentos = res.data.map(item => {
          return {
            ...item,
            dtpub: moment(item.created_at).format('DD/MM/YYYY'),
            status: item.inativar === 0 ? 'Ativo' : 'Inativo',
            lei: item.nr_lei + '/' + item.ano
          }
        })
      })
    },
    loadOrgaos () {
      const id = 32
      const url = `${baseApiUrl}/unidades-por-categoria/${id}`
      axios.get(url).then(res => {
        this.orgaos = res.data.map(item => {
          return {
            value: item.id,
            text: item.unidade
          }
        })
      })
    },
    loadCorrelato (item) {
      const id = item.id
      const url = `${baseApiUrl}/correlacionamentos/${id}`
      axios.get(url).then(res => {
        this.relacionamento = res.data
        this.codigoRelac = this.relacionamento.id
      })
      this.dialogCorrelato = true
    },
    loadLei (lei, mode = 'save') {
      this.mode = mode
      this.codigo = lei.id
      const id = lei.id
      const url = `${baseApiUrl}/legislacao/${id}`
      axios.get(url).then(res => {
        this.lei = res.data
        this.lei.correlacionado = Boolean(Number(this.lei.correlacionado))
        const idProp = this.lei.uid_proposicao
        if (!this.lei.data_publicacao) {
          this.data_pub = ''
        } else {
          this.data_pub = moment(this.lei.data_publicacao).format('DD/MM/YYYY')
          this.lei.data_publicacao = moment(this.lei.data_publicacao).format('YYYY-MM-DD')
        }
        if (idProp) {
          this.loadProposicao(idProp)
        }
      })
      this.dialog = false
      this.valid = true
      //  this.loadDatas()
      this.loadSituacoes()
      this.loadNormativas()
    },
    loadLeiHtml () {
      const id = this.lei.id
      const url = `${baseApiUrl}/legislacao-html/${id}`
      axios.get(url).then(res => {
        this.leiHtml = res.data
      })
      this.mode = "updateHtml"
    },
    loadAddLei (item) {
      const id = item.id
      const url = `${baseApiUrl}/legislacao/${id}`
      axios.get(url).then(res => {
        this.leift = res.data
        this.relacionamento.nr_lei = this.leift.numero
        this.relacionamento.ano = this.leift.ano
        this.anoleicorrelato = this.leift.ano
        this.nrleicorrelato = this.leift.numero
      })
      this.dialogFiltro = false
    },
    loadProcesso (item) {
      this.codProposicao = item.projeto + '/' + String(item.ano_projeto).substr(-2, 2)
      this.lei.uid_proposicao = item.id
      this.dialogProposicao = false
    },
    loadProposicao (idProp) {
      const url = `${baseApiUrl}/protocolo-proposicao/${idProp}`
      axios.get(url).then(res => {
        this.proposicao = res.data
        this.codProposicao = this.proposicao.projeto + '/' + String(this.proposicao.ano_projeto).substr(-2, 2)
      })
    },
    loadAnexo (anexo, mode = 'save') {
      this.mode = mode
      const id = anexo.id
      const url = `${baseApiUrl}/anexos-de-lei-update/${id}`
      axios.get(url).then(res => {
        this.anexo = res.data
        this.btnDel = Boolean(Number(this.anexo.deleted))
        this.anexo.usuario = this.user.id
        if (!this.anexo.data_publicacao) {
          this.date_pub = ''
        } else {
          this.date_pub = moment(this.anexo.data_publicacao).format('DD/MM/YYYY')
          this.anexo.data_publicacao = moment(this.anexo.data_publicacao).format('YYYY-MM-DD')
        }
      })
      this.DialogAnexo = true
    },
    loadModalAutor () {
      this.autor.usuario = this.user.id
      this.autor.uid_lei = this.lei.id
      this.autor.cat_interessado = 'AGP' // agente publico
      this.DialogAutor = true
    },
    loadAutorSel () {
      const item = this.filtro
      const id = this.autor.uid_interessado ? `/${this.autor.uid_interessado}` : `/${item}`
      const url = `${baseApiUrl}/agentes-por-id${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.autor.uid_interessado = this.pessoa.uid_agente
        this.autor.interessado = this.pessoa.agente
        this.autor.nome = this.pessoa.agente
        this.disabled = true
      })
    //  this.clPessoa()
    },
    loadLeiSel (item) {
      const id = item.id
      const url = `${baseApiUrl}/agentes-por-id/${id}`
      axios.get(url).then(res => {
        this.pessoa = res.data
        this.autor.uid_interessado = this.pessoa.uid_agente
        this.autor.interessado = this.pessoa.agente
        this.autor.nome = this.pessoa.agente
        this.disabled = true
      })
      //  this.clPessoa()
    },
    loadModalUnidade () {
      this.unidade.usuario = this.user.id
      this.unidade.uid_item = this.lei.id
      this.DialogUnidade = true
    },
    loadUnidadeSel () {
      const item = this.filtro
      const id = this.unidade.uid_sessao ? `/${this.unidade.uid_sessao}` : `/${item}`
      const url = `${baseApiUrl}/sessao-por-id${id}`
      axios.get(url).then(res => {
        this.unidad = res.data
        this.unidade.uid_sessao = this.unidad.uid_sessao
        this.unidade.prefixo = this.unidad.prefixo
        this.unidade.sessao = this.unidad.sessao
        this.disabled = true
      })
    //  this.clPessoa()
    },
    AddCorrelato () {
      this.relacionamento.usuario = this.user.id
      this.relacionamento.uid_lei = this.lei.id
      this.dialogCorrelato = true
    },
    AddAnexo () {
      this.anexo.usuario = this.user.id
      this.anexo.uid_lei = this.lei.id
      this.anexo.pasta = this.pastas.pasta
      this.DialogAnexo = true
    },
    reset () {
      this.$refs.form.reset()
      this.valid = true
      this.mode = 'save'
      this.lei = {}
      this.leiHtml = {}
      this.codigo = ''
      this.lei.usuario = this.user.id
      this.lei.uid_situacao = 7
    },
    loadAddPessoa () {

    },
    loadAddUnidade () {

    },
    loadFtAutor () {

    },
    loadFtUnidade () {

    },
    clearAutor () {
      this.autor = {}
      this.pessoa = {}
      this.items = []
    },
    clearUnidade () {
      this.unidade = {}
      this.unidad = {}
      this.items = []
      this.codUn = ''
    },
    clPessoa () {
      this.pessoa = {}
      this.items = []
      this.autor = {}
      this.autor.usuario = this.user.id
      this.autor.uid_lei = this.lei.id
      this.disabled = false
    },
    clUnidade () {
      this.unidade.usuario = this.user.id
      this.unidade.uid_item = this.lei.id
      this.disabled = false
      this.unidade = {}
      this.items = []
    },
    limpar () {
      this.mode = 'save'
      this.anexo = {}
      this.anexo.usuario = this.user.id
      this.anexo.uid_lei = this.lei.id
    },
    FecharDialog () {
      this.DialogAutor = false
      this.DialogAnexo = false
      this.DialogUnidade = false
      this.anexo = {}
      this.autor = {}
      this.unidade = {}
      this.mode = 'save'
      this.mod = 'save'
      this.codUn = ''
      this.limpar()
    },
    FecharDialogRel () {
      this.relacionamento = {}
      this.dialogCorrelato = false
    },
    loadDialog () {
      this.dialog = true
      this.codProposicao = ''
      this.loadLeis()
    },
    loadDialogFiltro () {
      this.dialogFiltro = true
      this.loadLeis()
    },
    loadDialogProposicao () {
      this.dialogProposicao = true
      this.loadProcessos()
      this.codProposicao = ''
    },
    loadDatas () {
      this.dateB()
      this.mudaData()
      //  this.mudaDataA()
    },
    loadUser () {
      this.lei.usuario = this.user.id
      this.lei.uid_situacao = 7
      this.lei.uuid = uuid.v1()
      this.loadNormativas()
      this.loadSituacoes()
      this.loadSessoes()
      this.loadTipoLeis()
      this.loadModos()
      this.loadTipos()
      this.loadDatas()
      this.loadOrgaos()
    }
  },
  mounted () {
    this.loadUser()
  }
}
</script>

<style scoped>
.altura {
  min-height: 150px !important;
}
.text-v-card {
  font-size: 1rem !important;
}
.codigo {
  max-width: 100% !important;
}
.v-busca-nome {
  max-width: 100% !important;
  height: 45px !important;
}
.v-input__prepend-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
  padding: auto !important;
  background-color: teal;
}
.v-icon-btn-outer {
  padding: 0px !important;
  width: 36px !important;
  height: 36px !important;
}
.v-icon-btn {
  margin-top: -7px !important;
  margin-right: -8px !important;
  padding: auto !important;
  background-color: rgb(12, 94, 46);
}
.btn-outer {
  margin-top: -7px !important;
  margin-left: -9px !important;
}
.btn-outer-right {
  margin-top: -7px !important;
  margin-right: -11px !important;
}
.v-size--default {
  height: 37px !important;
  min-width: 38px !important;
}

ul.filtro {
  position: absolute;
  min-width: 350px;
  top: 0px;
  left: 40px;
  padding: 2px 6px !important;
  background-color: #feffff;
  border: solid 1px #000;
  list-style: none;
  z-index: 1000;
}
ul.filtro li a {
  text-decoration: none;
  color: #333 !important;
}
ul.filtro li:hover {
  background-color: teal;
  color: #ffffff !important;
}
ul.filtro li a:hover {
  color: #ffffff !important;
}
.container {
  width: 98% !important;
}
.logo-foto {
  max-width: 95%;
}
</style>
